import { useConfig, useCookieConsent } from '@packages/utilities';
import Script from 'next/script';

import type { FC } from 'react';

/**
 * Cookie consent dependent component that adds the mouseflow tracking script
 * */
export const Mouseflow: FC = () => {
  const {
    tracking: { mouseflowProjectId },
  } = useConfig();
  const isConsentGiven = useCookieConsent('C0003');
  if (mouseflowProjectId === '') {
    return null;
  }
  if (!isConsentGiven) {
    return null;
  }
  if (document.getElementById('mouseflow-script') !== null) {
    return null;
  }

  return (
    <Script
      data-testid="mouseflow"
      defer
      id="mouseflow-script"
      src={`//cdn.mouseflow.com/projects/${mouseflowProjectId}.js`}
      type="text/javascript"
    />
  );
};
